import PayrollDocuments from "../common/PayrollDocuments";

const EmployeePayrollDocuments = () => <PayrollDocuments />;

export default EmployeePayrollDocuments;
